import { useEffect } from "react";
import { useRouter } from "next/router";
import { shouldOpenChatAfterLoad, bootSupChat } from "./config";
import { SupChatIcon } from "./SupChatIcon";
import SupChatStyles from "./SupChat.styles";

const SupChat = () => {
  const router = useRouter();
  const isOpen = shouldOpenChatAfterLoad(router?.query);

  const openChat = () => {
    bootSupChat(true);
  };

  useEffect(() => {
    if (isOpen) {
      bootSupChat(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SupChatStyles />
      <SupChatIcon
        id="supchat-trigger"
        onClick={openChat}
        boxSize="60px"
        position="fixed"
        zIndex={9997}
        cursor="pointer"
      />
    </>
  );
};

export default SupChat;
